const ChatBotEngine = {
  default: 'claude-v2',
  engines: [
    { modelName: 'Anthropic’s Claude 3.5', value: 'claude-v2', webLink: 'https://www.anthropic.com/news/claude-3-5-sonnet' },
    { modelName: 'OpenAI’s GPT-4', value: 'gpt4', webLink: 'https://openai.com/gpt-4' },
    { modelName: 'OpenAI’s GPT-3', value: 'gpt3', webLink: 'https://openai.com/blog/gpt-3-apps' },
  ],
};

export default ChatBotEngine;